// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__EGWct","left":"InfoRow_left__3T48S"};